import React from 'react';

import ThumbsUpSolid from '@/components/commons/icons/ThumbsUpSolid';
import ThumbsDownSolid from '@/components/commons/icons/ThumbsDownSolid';
import Check from '@/components/commons/icons/Check';
import RotateOutline from '@/components/commons/icons/RotateOutline';

export const cgStartCard = {
    title: 'Contacts game',
    buttonsAlign: 'col',
    subtitle: 'See how many contacts you can classify or merge in sixty seconds! Ready?',
    buttons: [{
        key: 'lets-go-button',
        label: 'Let’s go!',
        iconLeft: <ThumbsUpSolid className="w-4 h-4 text-white" />,
        value: '',
        background: 'cleanSlate',
        fontColor: 'cirrusWhite',

    }],
};

export const cgEndCard = {
    title: 'Time’s up. Great job!',
    buttonsAlign: 'row',
    subtitle: 'Come back tomorrow to try again, or give it another go right now!',
    cards: [
        {
            proposedCircle: 0,
        },
        {
            proposedCircle: 1,
        },
        {
            proposedCircle: 2,
        },
        {
            proposedCircle: null,
        },
    ],
    buttons: [
        {
            key: 'im-done-button',
            label: 'I’m done',
            value: '1',
            iconLeft: <Check className="w-4 h-4 text-cleanSlate" />,
            background: 'cirrusWhite',
            fontColor: 'cleanSlate',
        },
        {
            key: 'lets-go-button',
            label: 'Let’s go!',
            value: '2',
            iconLeft: <RotateOutline className="w-4 h-4 text-white" />,
            background: 'green-400',
            fontColor: 'cirrusWhite',
            border: 'transparent',
        },
    ],
};

export const closingModal = {
    buttons: [
        {
            key: 'quit-game-button',
            label: 'Quit the game',
            value: '1',
            iconLeft: <ThumbsDownSolid className="w-4 h-4 text-cleanSlate" />,
            background: 'cirrusWhite',
            fontColor: 'cleanSlate',
        },
        {
            key: 'keep-playing-button',
            label: 'Keep playing',
            value: '2',
            iconLeft: <ThumbsUpSolid className="w-4 h-4 text-white" />,
            background: 'green-400',
            fontColor: 'cirrusWhite',
            border: 'transparent',
        },
    ],
};
